import { emaSmoothing } from './smoothing-algorithms/ema';
import { gaussianSmoothing } from './smoothing-algorithms/gaussian';
import { smaSmoothing } from './smoothing-algorithms/sma';
import { SmoothingAlgorithm } from './smoothing-algorithm';
import { createChartDataToSmoothingDataAdapter } from './smoothing-input-adapter';
import { BucketInfo, SeriesVector, SimpleSeriesVector } from './types';

export function smoothData(
  data: SeriesVector[],
  bucketsByX: Map<number, BucketInfo>[],
  smoothingWindowSize: number,
  smoothingAlgorithm: SmoothingAlgorithm,
): SimpleSeriesVector[] {
  // TODO: Move the adapter call to Chart.
  const smoothingDataInput = createChartDataToSmoothingDataAdapter(data, bucketsByX);

  if (data.length !== 0 && smoothingWindowSize > 0) {
    switch (smoothingAlgorithm) {
      case 'smaCausal':
        return smaSmoothing(smoothingDataInput, smoothingWindowSize, 'causal');
      case 'smaCentered':
        return smaSmoothing(smoothingDataInput, smoothingWindowSize, 'centered');
      case 'emaCausal':
        return emaSmoothing(smoothingDataInput, smoothingWindowSize);
      case 'gaussianCentered':
        return gaussianSmoothing(smoothingDataInput, smoothingWindowSize);
      default:
        // eslint-disable-next-line no-console
        console.error(`Unknown smoothing algorithm: ${smoothingAlgorithm}`);
    }
  }

  return data.map(
    (values) =>
      values.map((point) => (Array.isArray(point) ? point[1] : point)) as SimpleSeriesVector,
  );
}
